import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-bc7a3324"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "list-box" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = { class: "product-title" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("待出库");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("已出库");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("已使用");
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("医院");
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("受检姓名");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("下单时间");
import { reactive, ref } from "vue";
import { List, NavBar, Icon, Tag, Row, Col, Tabs, Tab, Toast } from "vant";
import { querySampleList } from "@/api";
import { debounce } from "@/utils";
import router from "@/router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SampleList',
    setup: function (__props) {
        var _this = this;
        var active = ref(0);
        var loading = ref(false);
        var finished = ref(false);
        var productsList = ref([]);
        var pageParams = reactive({
            pageIndex: 0,
            pageSize: 10,
        });
        var getList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pageParams.pageIndex++;
                        return [4 /*yield*/, querySampleList({
                                pageIndex: pageParams.pageIndex,
                                pageSize: pageParams.pageSize,
                                sampleStatus: active.value || undefined,
                            }).catch(function (e) {
                                finished.value = true;
                            })];
                    case 1:
                        res = _b.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            if (pageParams.pageIndex === 1) {
                                productsList.value = [];
                            }
                            productsList.value = productsList.value.concat(res.data.records);
                            if (res.data.pages <= pageParams.pageIndex) {
                                finished.value = true;
                            }
                            if (!((_a = res.data) === null || _a === void 0 ? void 0 : _a.pages)) {
                                productsList.value = [];
                                finished.value = true;
                            }
                        }
                        else {
                            Toast(res.message);
                            finished.value = true;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetList = debounce(getList, 300);
        var onLoad = function () {
            loading.value = true;
            debounceGetList();
        };
        // 样本状态，1 待出库， 2 分配业务员， 3 分配医院 4 已经使用
        var viewDetails = function (item) {
            var sampleCode = item.sampleCode, sampleStatus = item.sampleStatus, refHospitalTime = item.refHospitalTime, hospitalName = item.hospitalName, hospitalDepartName = item.hospitalDepartName, hospitalDoctorName = item.hospitalDoctorName, testUserName = item.testUserName, orderCreateTime = item.orderCreateTime;
            router.push({
                path: "/salesman-sample-details",
                query: {
                    sampleCode: sampleCode,
                    sampleStatus: sampleStatus,
                    refHospitalTime: refHospitalTime,
                    hospitalName: hospitalName,
                    hospitalDepartName: hospitalDepartName,
                    hospitalDoctorName: hospitalDoctorName,
                    testUserName: testUserName,
                    orderCreateTime: orderCreateTime,
                },
            });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "样本管理",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createVNode(_unref(Tabs), {
                    active: active.value,
                    "onUpdate:active": _cache[2] || (_cache[2] = function ($event) { return ((active).value = $event); }),
                    color: "#3DABA4",
                    sticky: "",
                    onClick: _cache[3] || (_cache[3] =
                        function () {
                            pageParams.pageIndex = 0;
                            onLoad();
                        })
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_unref(Tab), { title: "全部" }),
                        _createVNode(_unref(Tab), {
                            title: "待出库",
                            name: 2
                        }),
                        _createVNode(_unref(Tab), {
                            title: "已出库",
                            name: 3
                        }),
                        _createVNode(_unref(Tab), {
                            title: "已使用",
                            name: 4
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(List), {
                                style: _normalizeStyle({ marginTop: '0.32rem' }),
                                loading: loading.value,
                                "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) { return ((loading).value = $event); }),
                                finished: finished.value,
                                "finished-text": "没有更多了",
                                onLoad: onLoad
                            }, {
                                default: _withCtx(function () { return [
                                    (productsList.value && productsList.value.length)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(productsList.value, function (item) {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "product-item",
                                                key: item.id
                                            }, [
                                                _createElementVNode("div", {
                                                    style: _normalizeStyle({ flex: 'auto', padding: '0.32rem' }),
                                                    onClick: function ($event) { return (viewDetails(item)); }
                                                }, [
                                                    _createElementVNode("p", _hoisted_4, [
                                                        _createTextVNode(_toDisplayString(item.sampleCode) + " ", 1),
                                                        (item.sampleStatus === 2)
                                                            ? (_openBlock(), _createBlock(_unref(Tag), {
                                                                key: 0,
                                                                style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                                type: "warning"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _hoisted_5
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]))
                                                            : _createCommentVNode("", true),
                                                        (item.sampleStatus === 3)
                                                            ? (_openBlock(), _createBlock(_unref(Tag), {
                                                                key: 1,
                                                                style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                                type: "success"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _hoisted_6
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]))
                                                            : _createCommentVNode("", true),
                                                        (item.sampleStatus === 4)
                                                            ? (_openBlock(), _createBlock(_unref(Tag), {
                                                                key: 2,
                                                                style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                                type: "danger"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _hoisted_7
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["style"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createVNode(_unref(Row), { class: "order-field" }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_unref(Col), {
                                                                class: "order-field-title",
                                                                span: "6"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _hoisted_8
                                                                ]; }),
                                                                _: 1
                                                            }),
                                                            _createVNode(_unref(Col), { span: "18" }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode(_toDisplayString(item.hospitalName), 1)
                                                                ]; }),
                                                                _: 2
                                                            }, 1024)
                                                        ]; }),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_unref(Row), { class: "order-field" }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_unref(Col), {
                                                                class: "order-field-title",
                                                                span: "6"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _hoisted_9
                                                                ]; }),
                                                                _: 1
                                                            }),
                                                            _createVNode(_unref(Col), { span: "18" }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode(_toDisplayString(item.testUserName), 1)
                                                                ]; }),
                                                                _: 2
                                                            }, 1024)
                                                        ]; }),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_unref(Row), { class: "order-field" }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_unref(Col), {
                                                                class: "order-field-title",
                                                                span: "6"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _hoisted_10
                                                                ]; }),
                                                                _: 1
                                                            }),
                                                            _createVNode(_unref(Col), { span: "18" }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode(_toDisplayString(item.orderCreateTime), 1)
                                                                ]; }),
                                                                _: 2
                                                            }, 1024)
                                                        ]; }),
                                                        _: 2
                                                    }, 1024)
                                                ], 12, _hoisted_3)
                                            ]));
                                        }), 128))
                                        : _createCommentVNode("", true)
                                ]; }),
                                _: 1
                            }, 8, ["style", "loading", "finished"])
                        ])
                    ]; }),
                    _: 1
                }, 8, ["active"])
            ]));
        };
    }
});
